import { gql, TypedDocumentNode } from "@apollo/client";

export type TaskDepartmentNotificationDestination = {
  id: string;
  workdayDepartmentName: string;
  email: string | null;
  emailEnabled: boolean;
  emailLastError: string | null;
  slackChannelId: string | null;
  slackChannelName: string | null;
  slackEnabled: boolean;
  slackLastError: string | null;
};

type TaskDepartmentNotificationDestinationEmail = Pick<
  TaskDepartmentNotificationDestination,
  "id" | "workdayDepartmentName" | "email" | "emailEnabled" | "emailLastError"
>;

type TaskDepartmentNotificationDestinationSlack = Pick<
  TaskDepartmentNotificationDestination,
  "id" | "workdayDepartmentName" | "slackChannelId" | "slackChannelName" | "slackEnabled" | "slackLastError"
>;

export type TaskDepartmentNotificationDestinationsQueryResponse = {
  taskDepartmentNotificationDestinations: TaskDepartmentNotificationDestinationEmail[];
};

export const TASK_DEPARTMENT_NOTIFICATION_DESTINATIONS_QUERY: TypedDocumentNode<TaskDepartmentNotificationDestinationsQueryResponse> = gql`
  query TaskDepartmentNotificationDestinationsQuery {
    taskDepartmentNotificationDestinations {
      id
      workdayDepartmentName
      email
      emailEnabled
      emailLastError
    }
  }
`;

export type TaskDepartmentNotificationDestinationSlackQueryResponse = {
  taskDepartmentNotificationDestinations: TaskDepartmentNotificationDestinationSlack[];
};

export const TASK_DEPARTMENT_NOTIFICATION_DESTINATION_SLACK_QUERY: TypedDocumentNode<TaskDepartmentNotificationDestinationSlackQueryResponse> = gql`
  query TaskDepartmentNotificationDestinationSlackQuery {
    taskDepartmentNotificationDestinations {
      id
      workdayDepartmentName
      slackChannelId
      slackChannelName
      slackEnabled
      slackLastError
    }
  }
`;

export type SlackChannel = {
  id: string;
  name: string;
};

export type SlackChannelsQueryResponse = {
  slackChannels: SlackChannel[];
};

export const SLACK_CHANNELS_QUERY: TypedDocumentNode<SlackChannelsQueryResponse> = gql`
  query SlackChannelsQuery {
    slackChannels {
      id
      name
    }
  }
`;
